import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

const avantages = () => {
  return (
    <Layout>
      <SEO title="Les avantages de la sophrologie" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h2>Les avantages</h2>
          </div>
          <div className="col-md-12">
            <p>
              La sophrologie se pratique les yeux fermés, y compris pour le
              sophrologue qui vous guide. Libéré du regard de l’autre, vous
              disposez ainsi d’un espace de liberté total.
            </p>

            <p>
              C’est un outil mobilisable par tous, partout, en tous lieux, quels
              que soient les bruits environnants.
            </p>

            <p>
              La pratique de la sophrologie ne requiert pas de matériel
              spécifique. Pour l’apprentissage de la méthode durant les séances,
              seules des chaises sont nécessaires.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default avantages
